import { CatalogFeature } from "@/types/catalog-feature";
import { SubscriptionPlanFeature } from "@/types/subscription-plan";

const HIDDEN_CUSTOM_PLAN_FEATURE_KEYS = new Set(["hotels_limit"]);

function normalizeKey(key: string | undefined | null): string {
  return key?.trim().toLowerCase() ?? "";
}

function isHiddenCustomPlanFeatureKey(key: string | undefined | null): boolean {
  return HIDDEN_CUSTOM_PLAN_FEATURE_KEYS.has(normalizeKey(key));
}

export function isHiddenCustomPlanFeature(
  feature: Pick<CatalogFeature, "key">,
) {
  return isHiddenCustomPlanFeatureKey(feature.key);
}

export function getVisibleCustomPlanFeatureOptions(
  features: CatalogFeature[],
): CatalogFeature[] {
  return features.filter((feature) => !isHiddenCustomPlanFeature(feature));
}

export function isVisibleCustomPlanFeature(
  planFeature: SubscriptionPlanFeature,
  hiddenFeatureIds: ReadonlySet<string>,
): boolean {
  const key = planFeature.key ?? planFeature.feature?.key;

  if (isHiddenCustomPlanFeatureKey(key)) {
    return false;
  }

  return !hiddenFeatureIds.has(planFeature.featureId);
}
